/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 17:50:14
 * @LastEditTime: 2019-08-13 18:06:51
 * @LastEditors: Please set LastEditors
 */
import React, { Component } from 'react';

export default class Page extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  closeMask = () => {
    this.props.refresh({
      "type": 4
    });
  }

  componentDidMount() {
    
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.showMask
          ?
          <div className="share-mask" onClick={this.closeMask}>
            
            <div className="poi"></div>
          </div>
          :
          ""
        }
      </React.Fragment>
     )
  }
}
